import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Destination, WarehouseDestinationResponse } from 'src/app/models/destination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { DestinationService } from 'src/app/services/destination.service';

@Component({
  selector: 'app-destination-warehouses-list',
  templateUrl: './destination-warehouses-list.component.html',
  styleUrls: ['./destination-warehouses-list.component.scss']
})
export class DestinationWarehousesListComponent implements OnChanges {
  @Input() destinationSelected: Destination = null;
  loading = false;
  destinationsWarehouse: WarehouseDestinationResponse[] = []
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  timeout = null;
  filterWord: string = null;
  selectedDate: string = new Date().toLocaleDateString('en-CA');

  constructor(
    private destinationService: DestinationService,
    private toastService: ToastrService
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['destinationSelected']) {
      this.selectedDate = new Date().toLocaleDateString('en-CA');
      this.getDestinationWarehouse();
    }
  }

  getDestinationWarehouse() {
    if (this.destinationSelected==null || this.selectedDate=="") {
      return;
    }

    this.loading = true;
    // const newDate = new Date(this.selectedDate);
    // newDate.setHours(0, 0, 0, 0); // aseguras que empiece a medianoche local

    // // Restar 6 horas → 6 * 60 * 60 * 1000 = 21_600_000 ms
    // const timestamp = newDate.getTime() + (24 * 60 * 60 * 1000);

    
    this.destinationService.getWarehouseDestinationsWithUserByEffectiveDateAndDestination(this.destinationSelected.id, this.selectedDate).subscribe({
      next: (response: ResponseObject) => {
        this.destinationsWarehouse = response.data;
        this.pagination.filter = this.destinationsWarehouse;
        this.pagination.total = this.destinationsWarehouse;
        this.resetPagination();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pueden obtener las bodegas asignada.", "Error")
        this.loading = false;
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }
}
